import { useState } from 'react';
import {
  Stack,
  StackDivider,
  Skeleton,
  VStack,
  Button
} from '@chakra-ui/react';
import { ProposalResponse, ResultsResponse } from 'pages/ProposalDetail';
import VoteRow from './VoteRow';

type Props = {
  results?: ResultsResponse;
  proposal?: ProposalResponse;
};

const VotesList: React.FC<Props> = ({ results, proposal }) => {
  const [showAllVotes, setShowAllVotes] = useState(false);

  return (
    <>
      {(!results || !proposal) && (
        <Stack divider={<StackDivider />} spacing={5}>
          {Array.from(Array(5).keys()).map((v) => (
            <Skeleton key={v} height='24px' borderRadius='md' />
          ))}
        </Stack>
      )}
      {results && results.votes.length === 0 && 'No votes have been casted'}
      {results && results.votes.length > 0 && (
        <VStack spacing={5} alignItems='stretch' divider={<StackDivider />}>
          {showAllVotes &&
            results.votes.map((vote: any, idx) => (
              <VoteRow key={idx} vote={vote} proposal={proposal!} />
            ))}
          {!showAllVotes &&
            results.votes
              .slice(0, 10)
              .map((vote: any, idx) => (
                <VoteRow key={idx} vote={vote} proposal={proposal!} />
              ))}
          {!showAllVotes && results.votes.length > 10 && (
            <Button
              onClick={() => setShowAllVotes(true)}
              variant='ghost'
              bg='gray.800'
            >
              Show more
            </Button>
          )}
        </VStack>
      )}
    </>
  );
};

export default VotesList;
